<template>
  <b-card
    title="จัดการสิทธิ์แอดมิน"
    no-body
  >
    <b-card
      no-body
    >
      <b-card-body>
        <!-- <div class="d-flex justify-content-between  flex-wrap"> -->
        <b-form @submit.prevent>
          <b-row>
            <!-- submit and reset -->
            <b-col>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="info"
                class="mr-1"
                @click="addnewAdmin"
              >
                เพิ่มแอดมินใหม่
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
    <b-table
      ref="staffadmin"
      striped
      hover
      responsive
      class="position-relative"
      :busy.sync="isBusy"
      :per-page="tableQuery.page_size"
      :current-page="tableQuery.page"
      :items="fetchAdmin"
      :fields="fields"
    >
      <template #cell(is_active)="data">
        <b-badge :variant="{true:'light-success', false:'light-primary'}[data.item.is_active]">
          {{ {true:'ให้ใช้งาน', false:'ระงับการใช้งาน'}[data.item.is_active] }}
        </b-badge>
      </template>
      <template #cell(permissionss)="data">
        <b-badge
          v-if="!data.item.invited_by"
          :variant="'light-danger'"
        >
          ไม่มี
        </b-badge>
        <div v-if="data.item.invited_by">
          {{ data.item.refer_by.phoneno }}<br>
          {{ data.item.refer_by.fname }} {{ data.item.refer_by.lname }}
        </div>
      </template>
      <template #cell(btns)="data">
        <div style="text-align:center;">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-info"
            size="sm"
            @click="viewAdmin(data.item)"
          >
            <feather-icon
              icon="EditIcon"
              class="mr-50"
            />
            แก้ไขข้อมูล
          </b-button>{{ ' ' }}
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-danger"
            size="sm"
            @click="deleteAdmin(data.item)"
          >
            <feather-icon
              icon="MinusIcon"
              class="mr-50"
            />
            ลบ
          </b-button>
        </div>
      </template>

    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

      <!-- page length -->
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="tableQuery.page_size"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
          v-model="tableQuery.page"
          :total-rows="totalRows"
          :per-page="tableQuery.page_size"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
// import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BTable, BBadge, BFormGroup, BFormSelect, BPagination, BButton, BCardBody, BRow, BCol, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Cleave from 'vue-cleave-component'
import moment from 'moment'

export default {
  components: {
    BCard,
    BTable,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    // Cleave,
    // BInputGroup,
    // BFormInput,
    // BInputGroupAppend,
    BButton,
    BCardBody,
    BRow,
    BCol,
    BForm,
    // // vSelect,
    // flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      bankListOptions: JSON.parse(localStorage.getItem('bank-lists') || '[]'),
      isBusy: false,
      pageOptions: [100, 200, 500, 1000],
      totalRows: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      tableQuery: {
        page: 1,
        page_size: 100,
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        { key: 'id', label: 'ADMIN#' },
        { key: 'phoneno', label: 'ยูสเซอร์' },
        { key: 'name', label: 'ชื่อ' },
        { key: 'is_active', label: 'อนุญาต' },
        { key: 'otp_issue_at', label: 'ใช้งานล่าสุด', formatter: val => moment(val).format('DD/MM/YYYY HH:mm') },
        { key: 'btns', label: 'ดำเนินการ' },
      ],
      /* eslint-disable global-require */
      items: [
      ],
      /* eslint-disable global-require */
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
  computed: {
    // getBankOptions() {
    //   return this.bankListOptions
    // },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    // this.fetchMember()
  },
  methods: {
    searchMember() {
      this.$refs.staffadmin.refresh()
    },
    clearSearch() {
      this.tableQuery = {
        page: 1,
        page_size: 100,
      }
      this.$refs.staffadmin.refresh()
    },
    deleteAdmin(data) {
      this.$swal({
        title: 'ยืนยันการลบแอดมิน?',
        text: `คุณกำลังจะยืนยันการลบแอดมิน ${data.phoneno} ${data.name} ใช่ไหม`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ใช่ ตกลง',
        customClass: {
          confirmButton: 'btn btn-info',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value)
          return this.$http.delete(`admin/${data.id}`)
        return { data: { success: false } }
      }).then(({ data: updateResult }) => {
        if (updateResult.success) {
          this.$swal({
            icon: 'success',
            title: 'ลบแอดมินเรียบร้อย',
            text: 'ยืนยันการลบแอดมินเรียบร้อย',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.$refs.staffadmin.refresh()
        }
      }).catch(err => {
        this.$bvToast.toast(`เกิดข้อผิดพลาด | ${err}`, {
          variant: 'danger',
          title: 'ยืนยันการลบแอดมินเรียบร้อยไม่สำเร็จ',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: false,
        })
      })
    },
    async fetchAdmin(ctx) {
      let query = ''
      if (this.tableQuery !== {}) {
        Object.keys(this.tableQuery).forEach((key, idx) => {
          if (idx > 0) query += '&'
          if (this.tableQuery[key].value)
            query += `${key}=${encodeURIComponent(this.tableQuery[key].value)}`
          else
            query += `${key}=${encodeURIComponent(this.tableQuery[key])}`
        })
      }

      const { data: _members } = await this.$http.get(`admin${query !== '' ? (`?${query}`) : ''}`)
      this.items = _members.staffs.data
      this.totalRows = _members.staffs.total
      return this.items
    },
    viewAdmin(data) {
      this.$router.push({ name: 'manage-admin-detail', params: { admin: data.phoneno } })
    },
    addnewAdmin() {
      this.$router.push({ name: 'manage-admin-detail', params: { admin: 'add-new-staff' } })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
